import SearchRequest from '@wwdev/product/SearchRequest';
import Filters from "@wwdev/product/filters";
import SliderFilter from "./SliderFilter";

class CustomFilters extends Filters {
	constructor() {
		super({
			productsearch: '[data-scope="productsearch"]',
			rangeform: '[data-scope="rangeform"]',
		});
	}

	initEventListeners() {
		super.initEventListeners();
		$(this.config.productsearch).off('.product').on('submit.product', 'form', this.handleSearch.bind(this));
		$(this.config.filters)
			.on('click.product', '[data-remove-filter]', this.removeFilter.bind(this))
			.on('submit.product', this.config.rangeform, this.handleRangeSlider.bind(this));
	}

	handleRangeSlider(event) {
		event.preventDefault();
		this.ctimeout ? clearTimeout(this.ctimeout) : null;
		this.ctimeout = setTimeout(() => {
			this.handleSearch(event);
		}, 200);
	}

	handleSearchByForm($form) {
		let formdata = $form.serializeObject();
		for(let i in formdata) {
			SearchRequest.setByKeyValue(i, formdata[i]);
		}
		SearchRequest.clearByKey('page')
		this.reload();
	}

	handleSearch(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		this.handleSearchByForm($form);
	}

	handleResponse(response) {
		super.handleResponse(response);
		$(this.config.productsearch).html(response.productsearch);
	}

	resetFilter(e) {
		SearchRequest.clearByKey('hours', {});
		SearchRequest.clearByKey('range', {});
		SearchRequest.clearByKey('location', {});
		return super.resetFilter(e);
	}

	removeFilter(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		SearchRequest.clearFilter($button.data('tree-id'), $button.data('remove-filter'));
		this.reload();
	}

	afterCallback() {
		super.afterCallback();
		new SliderFilter({
			scope: `${this.config.rangeform} input[type="range"]`
		});
	}
}

export default CustomFilters;